import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { BaseMaterial } from '../models'

export const url = '/libraries/management/types/baseMaterial/entries'
export interface BaseMaterialItem extends BaseMaterial {
    new?: boolean
}
@Injectable({
    providedIn: 'root'
})
export class BaseMaterialService {
    constructor(private http: HttpService) {}

    getAll(): Observable<BaseMaterialItem[]> {
        return this.http.get<BaseMaterialItem[]>(url)
    }

    remove(data: BaseMaterialItem[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: BaseMaterialItem[]): Observable<BaseMaterialItem[]> {
        return this.http.post<BaseMaterialItem[]>(url, { data })
    }
    update(data: BaseMaterialItem[]): Observable<BaseMaterialItem[]> {
        return this.http.put<BaseMaterialItem[]>(url, { data })
    }
}
